import { Lightning, Colors } from '@lightningjs/sdk';

export default class FocusContainer extends Lightning.Component {
  static _template() {
    return {
      Border: { collision: true },
    };
  }

  _focus() {
    this._Border.patch({
      texture: Lightning.Tools.getRoundRect(1599, 25, 0, 3, Colors('#02AC25').get(), false),
    });
  }

  _unfocus() {
    this._Border.patch({
      texture: Lightning.Tools.getRoundRect(1599, 25, 0, 3, Colors('#D6D6D6').get(), false),
    });
  }

  _handleHover() {
    this.fireAncestors('$setState', 'ProgressBar');
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }

  _enable() {
    this._Border.patch({
      texture: Lightning.Tools.getRoundRect(1599, 25, 0, 3, Colors('#02AC25').get(), false),
    });
  }

  get _Border() {
    return this.tag('Border');
  }
}
